export function spendingRequest(state={
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "FETCH_SPENDINGS_START":           
        case "UPDATE_SPENDING_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "FETCH_SPENDINGS_FULFILLED":           
        case "UPDATE_SPENDING_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "FETCH_SPENDINGS_ERROR":
        case "UPDATE_SPENDING_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}